export type LightingCategory = {
  slug: 'residential' | 'commercial';
  title: string;
  eyebrow: string;
  description: string;
  quoteLabel: string;
  image: string;
  alt: string;
  href: string;
};

export type DecorationService = {
  title: string;
  description: string;
  image: string;
  alt: string;
};

export const christmasHeroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/21fae7ba-b26a-4307-a425-5baed8528398.jpg';

export const lightingCategories: LightingCategory[] = [
  {
    slug: 'residential',
    title: 'Residential Christmas Lighting',
    eyebrow: 'For Homes',
    description:
      'Transform your home into a warm, welcoming holiday showpiece. We design and install roofline lights, wreaths, garlands, bush and tree lights, and landscape stake lights for a polished, festive look.',
    quoteLabel: 'Get a Residential Quote',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e9dbe8d8-a897-4cad-b9dc-631ab1b26d26.jpg',
    alt: 'Two-story home at dusk with warm white roofline Christmas lights, wreaths, and lit trees',
    href: '/christmas-lights/residential',
  },
  {
    slug: 'commercial',
    title: 'Commercial Christmas Lighting',
    eyebrow: 'For Businesses',
    description:
      'Help your business stand out this holiday season. We light storefronts, offices, restaurants, and shopping centers with clean, professional displays that welcome customers and visitors.',
    quoteLabel: 'Get a Commercial Quote',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/74fba098-61c3-4825-b430-f1faa6594742.jpg',
    alt: 'Shopping center storefronts at dusk with warm white roofline lights, lit columns, and wreaths',
    href: '/christmas-lights/commercial',
  },
];

export const decorationServices: DecorationService[] = [
  {
    title: 'Roof Lights',
    description: 'Clean, straight lines of warm light that outline your roofline and gables.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bf38f80b-3894-43f9-8919-773c85598a69.jpg',
    alt: 'Warm white Christmas bulbs installed along a roofline at dusk',
  },
  {
    title: 'Wreaths',
    description: 'Lush evergreen wreaths with bows for windows, doors, and entryways.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/af713999-8b65-4e5e-b1f5-e70f5b8b65ff.jpg',
    alt: 'Lit evergreen wreath with a red bow on a window',
  },
  {
    title: 'Bush Lights',
    description: 'Evenly lit shrubs and hedges that add a soft, festive glow to your landscape.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f299508c-5ad3-463c-b976-8f1273b52d75.jpg',
    alt: 'Round shrubs covered in warm white net lights',
  },
  {
    title: 'Tree Lights',
    description: 'Trunks and branches wrapped in warm lights for a striking yard centerpiece.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/43c8f780-dc3a-4054-8c24-4182f82a7366.jpg',
    alt: 'Front-yard tree wrapped in warm white Christmas lights',
  },
  {
    title: 'Stake Lights',
    description: 'Landscape stake lights that line walkways and driveways with a warm welcome.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e78b205d-14f9-421f-aadf-7f3bb9c132e3.jpg',
    alt: 'Walkway lined with glowing Christmas stake lights',
  },
  {
    title: 'Garlands',
    description: 'Lit evergreen garland for doorways, porches, railings, and columns.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/026c9237-2cc7-44c7-a49d-9144eeb924ff.jpg',
    alt: 'Front entry decorated with lit garland and red bows',
  },
];
